export default "__VITE_ASSET__tcfv$WLM__"